import { createFileRoute } from "@tanstack/react-router";

import PrivacyConsentPage from "@/features/dashboard/pages/profile/pages/privacy-consent";

export const Route = createFileRoute("/(app)/dashboard/settings/privacy")({
  component: () => (
    <main role="main" aria-label="Privacy and consent settings" className="min-h-screen w-full">
      <PrivacyConsentPage />
    </main>
  ),
});
